import { twicPicsSourceUrlResolver } from '@sceneio/middleware'

export const CanvasUIBackground = () => {
  return (
    <div className="tw-w-full tw-h-full tw-top-0 tw-left-0 tw-absolute ">
      <div className="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-bg-modal-overlay tw-z-10 md:tw-block tw-hidden" />
      <img
        data-twic-src={twicPicsSourceUrlResolver(
          'https://assets.scene.io/global/placeholders/canvas/toolbar.png?v2',
        )}
        className="tw-absolute tw-left-0 tw-top-0 md:tw-block tw-hidden tw-h-[250px]"
      />
      <img
        data-twic-src={twicPicsSourceUrlResolver(
          'https://assets.scene.io/global/placeholders/canvas/right-toolbars.png?v2',
        )}
        className="tw-absolute tw-right-0 tw-top-0 md:tw-block tw-hidden tw-w-[355px]"
      />
      <img
        data-twic-src={twicPicsSourceUrlResolver(
          'https://assets.scene.io/global/placeholders/canvas/copilot-header.png?v2',
        )}
        className="tw-absolute tw-right-0 tw-bottom-0 md:tw-block tw-hidden tw-w-[350px]"
      />
      <img
        data-twic-src={twicPicsSourceUrlResolver(
          'https://assets.scene.io/global/placeholders/canvas/fullscreen.png?v2',
        )}
        className="tw-absolute tw-left-0 tw-bottom-0 md:tw-block tw-hidden tw-w-[60px]"
      />
    </div>
  )
}
